module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_janita-kauhanen _A4.29129e9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_janita-kauhanen _A4.pdf
// module id = WV/L
// module chunks = 22